(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('task-object-type', {
            parent: 'entity',
            url: '/task-object-type?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.taskObjectType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/task-object-type/task-object-types.html',
                    controller: 'TaskObjectTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('taskObjectType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('task-object-type-detail', {
            parent: 'task-object-type',
            url: '/task-object-type/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.taskObjectType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/task-object-type/task-object-type-detail.html',
                    controller: 'TaskObjectTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('taskObjectType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TaskObjectType', function($stateParams, TaskObjectType) {
                    return TaskObjectType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'task-object-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('task-object-type-detail.edit', {
            parent: 'task-object-type-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/task-object-type/task-object-type-dialog.html',
                    controller: 'TaskObjectTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TaskObjectType', function(TaskObjectType) {
                            return TaskObjectType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('task-object-type.new', {
            parent: 'task-object-type',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/task-object-type/task-object-type-dialog.html',
                    controller: 'TaskObjectTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                key: null,
                                apiUrl: null,
                                backendUrl: null,
                                frontendUrl: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('task-object-type', null, { reload: 'task-object-type' });
                }, function() {
                    $state.go('task-object-type');
                });
            }]
        })
        .state('task-object-type.edit', {
            parent: 'task-object-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/task-object-type/task-object-type-dialog.html',
                    controller: 'TaskObjectTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TaskObjectType', function(TaskObjectType) {
                            return TaskObjectType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('task-object-type', null, { reload: 'task-object-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('task-object-type.delete', {
            parent: 'task-object-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/task-object-type/task-object-type-delete-dialog.html',
                    controller: 'TaskObjectTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TaskObjectType', function(TaskObjectType) {
                            return TaskObjectType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('task-object-type', null, { reload: 'task-object-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
